import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';

import { getActualScheduleStartDate } from './get-actual-schedule-start-date';
import { getScheduleEndDate } from './get-schedule-end-date';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const getTimeframeSchedules = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  schedules.filter(
    (schedule) =>
      getActualScheduleStartDate(schedule) <= endDate &&
      (!schedule.endDate || getScheduleEndDate(schedule)! >= startDate),
  );
